var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainBageSectionBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2489_1882)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "url(#paint0_linear_2489_1882)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7733 306.822C184.014 306.822 255.547 235.289 255.547 147.049C255.547 58.8082 184.014 -12.7247 95.7733 -12.7247C7.53297 -12.7247 -64 58.8082 -64 147.049C-64 235.289 7.53297 306.822 95.7733 306.822Z",
    stroke: "#7D0633",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7737 254.115C154.905 254.115 202.84 206.18 202.84 147.049C202.84 87.9173 154.905 39.9819 95.7737 39.9819C36.6424 39.9819 -11.293 87.9173 -11.293 147.049C-11.293 206.18 36.6424 254.115 95.7737 254.115Z",
    stroke: "#7D0633",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7729 201.403C125.792 201.403 150.128 177.068 150.128 147.048C150.128 117.029 125.792 92.6936 95.7729 92.6936C65.7535 92.6936 41.418 117.029 41.418 147.048C41.418 177.068 65.7535 201.403 95.7729 201.403Z",
    stroke: "#7D0633",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2489_1882)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2489_1882)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.6484,
    cy: 149.586,
    r: 25,
    fill: "#5F0527"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2489_1882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3511 140.113C91.6123 139.428 91.9716 138.796 92.505 138.285C94.6386 136.205 98.1657 136.728 99.6135 139.341C100.702 141.322 101.856 143.26 102.977 145.219C104.85 148.474 106.744 151.729 108.594 154.995C110.151 157.727 108.464 161.178 105.372 161.646C103.478 161.929 101.704 161.058 100.724 159.36C99.0801 156.497 97.4254 153.634 95.7817 150.782C95.749 150.716 95.7055 150.662 95.6619 150.608C95.4877 150.466 95.4115 150.259 95.3027 150.074C94.5733 148.79 93.8222 147.516 93.0928 146.242C92.6247 145.415 92.1349 144.598 91.6668 143.771C91.2422 143.031 91.0463 142.225 91.068 141.376C91.1007 140.941 91.1551 140.505 91.3511 140.113Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3522 140.113C91.2543 140.505 91.1672 140.897 91.1454 141.311C91.1127 142.225 91.3414 143.074 91.7986 143.869C92.996 145.927 94.1935 147.995 95.38 150.063C95.4889 150.248 95.576 150.433 95.6849 150.607C95.0317 151.74 94.3785 152.861 93.7145 153.993C92.8001 155.571 91.8856 157.161 90.9603 158.739C90.9168 158.739 90.9059 158.718 90.895 158.685C90.8841 158.598 90.9168 158.522 90.9386 158.434C91.3849 156.802 91.0148 155.354 89.8935 154.113C89.2077 153.362 88.3368 152.937 87.3353 152.796C86.029 152.61 84.8751 152.948 83.8409 153.764C83.6559 153.906 83.5361 154.113 83.3184 154.222C83.2748 154.222 83.2531 154.2 83.2422 154.167C83.7647 153.264 84.2764 152.36 84.7989 151.457C86.9543 147.712 89.1097 143.967 91.276 140.233C91.2978 140.19 91.3305 140.157 91.3522 140.113Z",
    fill: "#A10841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2842 154.2C83.4911 154.015 83.687 153.819 83.9047 153.645C86.55 151.555 90.5234 153.068 91.1004 156.377C91.2419 157.172 91.1657 157.934 90.9262 158.696C90.9153 158.761 90.9044 158.816 90.8827 158.881C90.7847 159.055 90.6976 159.24 90.5887 159.414C89.6199 161.015 88.1938 161.809 86.3214 161.689C84.1769 161.537 82.4896 159.926 82.1956 157.792C82.0541 156.758 82.261 155.789 82.7944 154.897C82.9032 154.701 83.0339 154.526 83.1536 154.331C83.208 154.287 83.1863 154.2 83.2842 154.2Z",
    fill: "#CF0A54"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M205.348 146.75C205.348 148.2 204.172 149.375 202.723 149.375C201.273 149.375 200.098 148.2 200.098 146.75C200.098 145.3 201.273 144.125 202.723 144.125C204.172 144.125 205.348 145.3 205.348 146.75Z",
    fill: "#E30B5C",
    fillOpacity: 0.3,
    stroke: "#7D0633",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.848 101.75C128.848 103.2 127.672 104.375 126.223 104.375C124.773 104.375 123.598 103.2 123.598 101.75C123.598 100.3 124.773 99.1249 126.223 99.1249C127.672 99.1249 128.848 100.3 128.848 101.75Z",
    fill: "#E30B5C",
    fillOpacity: 0.3,
    stroke: "#7D0633",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1344.77 306.822C1433.01 306.822 1504.55 235.289 1504.55 147.049C1504.55 58.8082 1433.01 -12.7247 1344.77 -12.7247C1256.53 -12.7247 1185 58.8082 1185 147.049C1185 235.289 1256.53 306.822 1344.77 306.822Z",
    stroke: "#7D0633",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.77 254.115C1403.9 254.115 1451.84 206.18 1451.84 147.049C1451.84 87.9173 1403.9 39.9819 1344.77 39.9819C1285.64 39.9819 1237.71 87.9173 1237.71 147.049C1237.71 206.18 1285.64 254.115 1344.77 254.115Z",
    stroke: "#7D0633",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.77 201.403C1374.79 201.403 1399.13 177.068 1399.13 147.048C1399.13 117.029 1374.79 92.6936 1344.77 92.6936C1314.75 92.6936 1290.42 117.029 1290.42 147.048C1290.42 177.068 1314.75 201.403 1344.77 201.403Z",
    stroke: "#7D0633",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2489_1882)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2489_1882)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1344.65,
    cy: 149.586,
    r: 25,
    fill: "#5F0527"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2489_1882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1332.09 153.786C1332.09 154.997 1332.36 155.922 1332.71 156.484C1332.89 156.803 1333.16 157.068 1333.48 157.252C1333.8 157.435 1334.17 157.531 1334.54 157.528C1335.43 157.528 1336.25 157.308 1337.83 155.133C1339.09 153.391 1340.58 150.951 1341.58 149.41L1343.28 146.812C1344.45 145.008 1345.81 143.003 1347.38 141.639C1348.66 140.534 1350.03 139.918 1351.42 139.918C1353.74 139.918 1355.96 141.261 1357.66 143.782C1359.51 146.542 1360.42 150.019 1360.42 153.608C1360.42 155.741 1359.99 157.308 1359.28 158.546C1358.58 159.744 1357.23 160.94 1354.96 160.94V157.528C1356.9 157.528 1357.38 155.745 1357.38 153.704C1357.38 150.797 1356.7 147.569 1355.21 145.264C1354.14 143.628 1352.76 142.629 1351.25 142.629C1349.61 142.629 1348.29 143.861 1346.81 146.059C1346.02 147.227 1345.21 148.65 1344.3 150.256L1343.3 152.017C1341.29 155.569 1340.78 156.378 1339.78 157.713C1338.02 160.06 1336.52 160.94 1334.54 160.94C1332.19 160.94 1330.7 159.927 1329.79 158.399C1329.03 157.154 1328.66 155.521 1328.66 153.659L1332.09 153.786Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.37 144.023C1332.94 141.607 1335.21 139.918 1337.81 139.918C1339.32 139.918 1340.82 140.358 1342.38 141.636C1344.09 143.028 1345.91 145.321 1348.19 149.099L1349.01 150.455C1350.98 153.727 1352.1 155.408 1352.75 156.203C1353.6 157.222 1354.19 157.524 1354.95 157.524C1356.9 157.524 1357.38 155.741 1357.38 153.7L1360.41 153.605C1360.41 155.739 1359.99 157.306 1359.27 158.544C1358.58 159.744 1357.23 160.94 1354.95 160.94C1353.54 160.94 1352.29 160.634 1350.9 159.332C1349.84 158.333 1348.6 156.557 1347.64 154.961L1344.79 150.22C1343.36 147.84 1342.05 146.066 1341.29 145.267C1340.48 144.398 1339.43 143.355 1337.76 143.355C1336.4 143.355 1335.25 144.303 1334.29 145.752L1331.37 144.023Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.76 143.355C1336.4 143.355 1335.25 144.303 1334.29 145.752C1332.93 147.801 1332.09 150.852 1332.09 153.786C1332.09 154.997 1332.36 155.922 1332.71 156.484L1329.78 158.399C1329.03 157.154 1328.66 155.521 1328.66 153.659C1328.66 150.275 1329.6 146.747 1331.37 144.023C1332.94 141.607 1335.21 139.918 1337.81 139.918L1337.76 143.355Z",
    fill: "#CF0A54"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1197.85 204.563C1197.85 206.013 1196.67 207.188 1195.22 207.188C1193.77 207.188 1192.6 206.013 1192.6 204.563C1192.6 203.114 1193.77 201.938 1195.22 201.938C1196.67 201.938 1197.85 203.114 1197.85 204.563Z",
    fill: "#E30B5C",
    fillOpacity: 0.3,
    stroke: "#7D0633",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.6 146.75C1240.6 148.2 1239.42 149.375 1237.97 149.375C1236.52 149.375 1235.35 148.2 1235.35 146.75C1235.35 145.3 1236.52 144.125 1237.97 144.125C1239.42 144.125 1240.6 145.3 1240.6 146.75Z",
    fill: "#E30B5C",
    fillOpacity: 0.3,
    stroke: "#7D0633",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.85 101.75C1377.85 103.2 1376.67 104.375 1375.22 104.375C1373.77 104.375 1372.6 103.2 1372.6 101.75C1372.6 100.3 1373.77 99.1249 1375.22 99.1249C1376.67 99.1249 1377.85 100.3 1377.85 101.75Z",
    fill: "#E30B5C",
    fillOpacity: 0.3,
    stroke: "#7D0633",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.5 645C336.723 645 405 576.723 405 492.5C405 408.277 336.723 340 252.5 340C168.277 340 100 408.277 100 492.5C100 576.723 168.277 645 252.5 645Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.774 601.84C312.905 601.84 360.84 553.905 360.84 494.773C360.84 435.642 312.905 387.707 253.774 387.707C194.642 387.707 146.707 435.642 146.707 494.773C146.707 553.905 194.642 601.84 253.774 601.84Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.773 549.128C283.792 549.128 308.128 524.793 308.128 494.773C308.128 464.754 283.792 440.418 253.773 440.418C223.753 440.418 199.418 464.754 199.418 494.773C199.418 524.793 223.753 549.128 253.773 549.128Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2489_1882)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 254.223,
    cy: 494.563,
    r: 25,
    fill: "#5F0527"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2489_1882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.353 486.333C263.334 486.196 263.213 486.12 263.114 486.111C263.015 486.103 260.913 485.947 260.913 485.947C260.913 485.947 259.453 484.498 259.293 484.338C259.132 484.177 258.819 484.226 258.698 484.262C258.68 484.267 258.379 484.36 257.881 484.514C257.393 483.111 256.533 481.821 255.019 481.821C254.977 481.821 254.934 481.823 254.891 481.826C254.46 481.256 253.927 481.009 253.466 481.009C249.939 481.009 248.254 485.418 247.726 487.658C246.356 488.083 245.382 488.385 245.258 488.424C244.493 488.664 244.469 488.688 244.368 489.409C244.293 489.954 242.291 505.433 242.291 505.433L257.887 508.355L266.338 506.527C266.338 506.527 263.371 486.471 263.353 486.333ZM257.019 484.781L255.699 485.189C255.7 485.096 255.7 485.005 255.7 484.905C255.7 484.033 255.579 483.33 255.385 482.774C256.165 482.872 256.684 483.759 257.019 484.781ZM254.417 482.947C254.634 483.49 254.775 484.27 254.775 485.322C254.775 485.376 254.775 485.426 254.774 485.475C253.916 485.741 252.983 486.03 252.049 486.319C252.573 484.294 253.557 483.316 254.417 482.947ZM253.369 481.955C253.521 481.955 253.675 482.006 253.822 482.107C252.691 482.639 251.48 483.979 250.968 486.654L248.814 487.321C249.413 485.281 250.836 481.955 253.369 481.955Z",
    fill: "#CF0A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.114 486.111C263.015 486.103 260.913 485.947 260.913 485.947C260.913 485.947 259.454 484.498 259.293 484.337C259.233 484.278 259.152 484.247 259.068 484.234L257.889 508.355L266.339 506.527C266.339 506.527 263.372 486.47 263.353 486.333C263.334 486.196 263.214 486.119 263.114 486.111Z",
    fill: "#A10841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.02 490.781L253.978 493.88C253.978 493.88 253.065 493.393 251.946 493.393C250.305 493.393 250.222 494.422 250.222 494.682C250.222 496.098 253.912 496.64 253.912 499.956C253.912 502.565 252.258 504.244 250.027 504.244C247.35 504.244 245.98 502.578 245.98 502.578L246.697 500.21C246.697 500.21 248.105 501.418 249.292 501.418C250.068 501.418 250.384 500.807 250.384 500.361C250.384 498.514 247.356 498.432 247.356 495.397C247.356 492.844 249.189 490.372 252.89 490.372C254.315 490.372 255.02 490.781 255.02 490.781Z",
    fill: "#5F0527"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 361,
    cy: 599,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.625 599C363.625 600.45 362.45 601.625 361 601.625C359.55 601.625 358.375 600.45 358.375 599C358.375 597.55 359.55 596.375 361 596.375C362.45 596.375 363.625 597.55 363.625 599Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148,
    cy: 381,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.625 381C150.625 382.45 149.45 383.625 148 383.625C146.55 383.625 145.375 382.45 145.375 381C145.375 379.55 146.55 378.375 148 378.375C149.45 378.375 150.625 379.55 150.625 381Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 335,
    cy: 425,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.625 425C337.625 426.45 336.45 427.625 335 427.625C333.55 427.625 332.375 426.45 332.375 425C332.375 423.55 333.55 422.375 335 422.375C336.45 422.375 337.625 423.55 337.625 425Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153,
    cy: 530,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.625 530C155.625 531.45 154.45 532.625 153 532.625C151.55 532.625 150.375 531.45 150.375 530C150.375 528.55 151.55 527.375 153 527.375C154.45 527.375 155.625 528.55 155.625 530Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 549,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.625 549C258.625 550.45 257.45 551.625 256 551.625C254.55 551.625 253.375 550.45 253.375 549C253.375 547.55 254.55 546.375 256 546.375C257.45 546.375 258.625 547.55 258.625 549Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1187.5 645C1271.72 645 1340 576.723 1340 492.5C1340 408.277 1271.72 340 1187.5 340C1103.28 340 1035 408.277 1035 492.5C1035 576.723 1103.28 645 1187.5 645Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.77 601.84C1247.9 601.84 1295.84 553.905 1295.84 494.773C1295.84 435.642 1247.9 387.707 1188.77 387.707C1129.64 387.707 1081.71 435.642 1081.71 494.773C1081.71 553.905 1129.64 601.84 1188.77 601.84Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.77 549.128C1218.79 549.128 1243.13 524.793 1243.13 494.773C1243.13 464.754 1218.79 440.418 1188.77 440.418C1158.75 440.418 1134.42 464.754 1134.42 494.773C1134.42 524.793 1158.75 549.128 1188.77 549.128Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2489_1882)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 495,
    r: 25,
    fill: "#5F0527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.51 492.241H1189.05H1188.94V492.136V482.709C1188.94 482.185 1188.32 481.976 1188 482.395L1175.85 496.85C1175.75 496.955 1175.75 497.06 1175.75 497.164C1175.75 497.269 1175.75 497.374 1175.75 497.479C1175.75 497.583 1175.85 497.688 1175.96 497.688C1176.06 497.793 1176.17 497.793 1176.27 497.793H1188.73H1188.84V497.898V507.325C1188.84 507.849 1189.47 508.058 1189.78 507.639L1201.93 493.079C1202.04 492.974 1202.04 492.87 1202.04 492.765C1202.04 492.66 1202.04 492.555 1202.04 492.451C1202.04 492.346 1201.93 492.241 1201.83 492.241C1201.72 492.241 1201.62 492.241 1201.51 492.241Z",
    fill: "#CF0A54"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1302,
    cy: 593,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.63 593C1304.63 594.45 1303.45 595.625 1302 595.625C1300.55 595.625 1299.38 594.45 1299.38 593C1299.38 591.55 1300.55 590.375 1302 590.375C1303.45 590.375 1304.63 591.55 1304.63 593Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1188.47,
    cy: 387.975,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.1 387.975C1191.1 389.424 1189.92 390.6 1188.47 390.6C1187.02 390.6 1185.85 389.424 1185.85 387.975C1185.85 386.525 1187.02 385.35 1188.47 385.35C1189.92 385.35 1191.1 386.525 1191.1 387.975Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1295.72,
    cy: 494.475,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.35 494.475C1298.35 495.924 1297.17 497.1 1295.72 497.1C1294.27 497.1 1293.1 495.924 1293.1 494.475C1293.1 493.025 1294.27 491.85 1295.72 491.85C1297.17 491.85 1298.35 493.025 1298.35 494.475Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1088,
    cy: 530,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.63 530C1090.63 531.45 1089.45 532.625 1088 532.625C1086.55 532.625 1085.38 531.45 1085.38 530C1085.38 528.55 1086.55 527.375 1088 527.375C1089.45 527.375 1090.63 528.55 1090.63 530Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1191,
    cy: 549,
    rx: 3,
    ry: 3,
    fill: "#E30B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.63 549C1193.63 550.45 1192.45 551.625 1191 551.625C1189.55 551.625 1188.38 550.45 1188.38 549C1188.38 547.55 1189.55 546.375 1191 546.375C1192.45 546.375 1193.63 547.55 1193.63 549Z",
    stroke: "#7D0633",
    strokeOpacity: 0.6,
    strokeWidth: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2489_1882",
    x: 58.6484,
    y: 112.586,
    width: 74.3516,
    height: 74.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_1882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2489_1882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2489_1882",
    x: 58.6484,
    y: 112.586,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_1882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2489_1882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2489_1882",
    x: 1307.65,
    y: 112.586,
    width: 74.3516,
    height: 74.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_1882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2489_1882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2489_1882",
    x: 1307.65,
    y: 112.586,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_1882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2489_1882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2489_1882",
    x: 217.223,
    y: 457.563,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_1882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2489_1882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2489_1882",
    x: 1152,
    y: 458,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_1882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2489_1882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2489_1882",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30B5C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2489_1882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2489_1882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.3238,
    height: 24.7112,
    fill: "white",
    transform: "translate(82 137)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2489_1882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7484,
    height: 21.0227,
    fill: "white",
    transform: "translate(1328.66 139.918)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2489_1882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.4878,
    height: 27.4879,
    fill: "white",
    transform: "translate(240.594 480.935)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBageSectionBg);
export default __webpack_public_path__ + "static/media/mainBageSectionBG.15bc8006b12be8aa45812cc9be49ddc7.svg";
export { ForwardRef as ReactComponent };